import { useEffect, useState } from "react";
import { APP_VERSION, AURORA_PAYMENT_URL } from "configs";
import { useSearchParams, Navigate, useLocation } from "react-router-dom";
import { getMerchantRequest } from "reducers/global";
import IMerchant from "interfaces/IMerchant";
import useAppDispatch from "hooks/useAppDispatch";
import MerchantService from "services/MerchantService";
import TokenService from "services/TokenService";
import "./index.css";

const NotFound = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();

    const [searchParams] = useSearchParams();
    const merchantId = searchParams.get("merchant_id");
    const tokenUrl = searchParams.get("token");
    const guid = searchParams.get("guid");

    const [merchant, setMerchant] = useState<IMerchant>();

    useEffect(() => {
        const fetchMerchant = async (merchantId: number, token: string) => {
            try {
                const newToken = await TokenService.verifyToken(merchantId, token);
                dispatch(getMerchantRequest(newToken));
                const data = await MerchantService.getById(merchantId);
                if (data) setMerchant(data);
            } catch (error) {
                console.log(error);
            }
        };

        const fetchMerchantGuid = async (guid: string) => {
            try {
                let merchant = await MerchantService.getByGuid(guid);
                dispatch(getMerchantRequest(merchant.token || ""));
                if (merchant) {
                    setMerchant(merchant);
                }
            } catch (error) {
                console.log(error);
            }
        };

        if (merchantId && tokenUrl && location.pathname === "/not-found") {
            fetchMerchant(parseInt(merchantId), tokenUrl);
        }

        if (guid) {
            fetchMerchantGuid(guid);
        }
    }, [dispatch, location.pathname, merchantId, tokenUrl, guid]);

    if (merchant && merchant.merchantId && guid) return <Navigate to={`/?guid=${guid}`} />;

    if (merchant && merchant.merchantId && merchantId && tokenUrl)
        return <Navigate to={`/?merchant_id=${merchantId}&token=${tokenUrl}`} />;

    return (
        <div className="w-screen h-screen flex justify-center pt-45 px-4.5 not-found lg:pt-49.25">
            <div className="max-w-[630px] flex flex-col items-center">
                <p className="text-18 leading-22 text-not-found font-semibold lg:text-24 lg:leading-29.25">404</p>
                <p className="mt-2.75 text-6 leading-7.25 text-white font-bold lg:text-8 lg:leading-9.75 lg:mt-2.25">
                    Page Not Found
                </p>
                <p className="mt-1.25 text-4 leading-5 text-white font-medium text-center lg:text-4.5 lg:leading-5.5 lg:mt-3">
                    The page you are looking for might have been removed, had its name changed, or is temporarily
                    unavailable.
                </p>
                <div className="mt-8.75 lg:mt-9.75">
                    <a
                        href={AURORA_PAYMENT_URL}
                        className="block py-4.5 px-13.5 bg-secondary rounded-md text-4 leading-5 text-white font-bold lg:text-4.5 lg:leading-5.5 lg:pt-4.5 lb:pb-4 lg:px-14.25"
                    >
                        Aurora Payments Website
                    </a>
                </div>
            </div>
            <p className="absolute bottom-2.5 right-2.5 text-white font-medium">Version: {APP_VERSION}</p>
        </div>
    );
};

export default NotFound;
